import { Component, OnInit, Input } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { WebParameterContext } from '../../../../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../../service/messageclient.service';
declare var app;

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.page.html',
  styleUrls: ['./search-modal.page.scss'],
})
export class SearchModalPage implements OnInit {
  // @Input() Type: string;
  loading: boolean = false;//加载效果
  tabstranIndex:number =-1; // 孕期热搜
  tabstranIndex2:number =-1; // 宝期热搜
  apiObj = {
    status: false,
    msg: ''
  };//接口状态
  hotSearchInfo1: Array<any> = []; //宝期热搜数据源
  hotSearchInfo2: Array<any> = [];// 孕期热搜数据源
  hotSearchTagname:any; // 宝期热搜搜名称内容
  hotSearchTagname2:any; // 孕期热搜名称内容
  searchValue:any = "";//查询值
  constructor(
    public navParams: NavParams,
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
  ) {
    // console.log(navParams.get("ConfigName"),navParams.get("PageName"));
  }

  ngOnInit() {
    // console.log(this.Type, "init");
    this.LoadData();
    // let obj={};
    // let _objarr:any={
    //   "Value": "关键字",
    //     "LikeType": "Middle",
    //     "Type": "Like"
    // }
    // obj[ "b_TagName"] = _objarr;
    // console.log(obj,"拼接好的字段");
  }
/**
 * 内容库跳转
 */
  searchModal(){
    const that=this;
    let url:Array<string>=new Array<string>();
    url.push("/tabs/contact/HomeSFA/add/20200628175213");
    url.push("/tabs/contact/ContentLibraryHome/20200628175534/20200628175539[Isfresh]");
    localStorage.setItem("backurl",JSON.stringify(url));
    // that.router.navigateByUrl("/tabs/contact/ContentLibraryHome/"+that.com.getNowDatetime);
    that.com.Go("/tabs/contact/ContentLibraryHome/"+that.com.getNowDatetime);
    this.modalController.dismiss({
      'modalStatus': false
    });
  }
  dismissModal() {
    this.modalController.dismiss({
      'modalStatus': false
    });
  }
  // 确定按钮
  comfireModal() {
   
    const that =this;
    if( !that.searchValue){
      that.msg.Alert("搜索内容不能为空哦！");
      return;
    }
    this.modalController.dismiss({
      'modalStatus': false
    });
    // this.com.setHistoryUrl();
    that.com.Go("/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime,{
      searchValue:that.searchValue, //搜索关键字
      hotSearchTagname2:that.hotSearchTagname2,//孕期热搜名称内容
      hotSearchTagname:that.hotSearchTagname, //宝期热搜名称内容
      type:1 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
    });
  }

  searchEvent(e, type: string = 'type') {

    const that = this;
    // if (!that.searchValue) {
    //   that.msg.Alert("物流单号不能为空哦！");
    //   return;
    // }
   
   
  }


  LoadData() {
    const that = this;

    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';

    let _obj = {};
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBHighFrequencyTagXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.PageNumber = 1;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    // body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(item=>{
          if(item.a_Type ==1){
            that.hotSearchInfo1.push(item);
          }
          if(item.a_Type ==2){
            that.hotSearchInfo2.push(item); 
          }
        })
        that.hotSearchTagname=that.hotSearchInfo1[0].a_TagName; //宝期热搜搜名称内容
        that.hotSearchTagname2= that.hotSearchInfo2[0].a_TagName; //孕期热搜搜名称内容
      
        console.log( that.hotSearchTagname2);
        console.log( that.hotSearchTagname,"宝期热搜搜名称内容")
      } else {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
        // that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = "网络繁忙，请稍后再试！";
      that.loading = true;
      console.log(error);
    });
  }
  //孕期热搜
  EventTab(item,num){
    const that =this;
    console.log(num);
    that.tabstranIndex= num;
    that.hotSearchTagname2= item.a_TagName;
    this.modalController.dismiss({
      'modalStatus': false
    });
    // this.com.setHistoryUrl();
    // this.router.navigate(["/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime], {
    //   queryParams: {
    //     a_ID:item.a_ID,
    //     searchValue:item.a_TagName,
    //     type:1 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
    //   }
    // });
    this.com.Go("/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime,{
      a_ID:item.a_ID,
      searchValue:item.a_TagName,
      type:1 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
    });
  }
  EventTab2(item,num){
    const that =this;
    that.tabstranIndex2= num;
    that.hotSearchTagname= item.a_TagName;
    this.modalController.dismiss({
      'modalStatus': false
    });
    // this.com.setHistoryUrl();
    that.com.Go("/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime,{
      a_ID:item.a_ID,
      searchValue:item.a_TagName,
      type:1 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
    });
  }
}
